var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/core-js/parse-int", "@babel/runtime-corejs2/core-js/object/assign", "react", "prop-types", "../../propTypes", "../../UI/Interchange/Interchange"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/core-js/parse-int"), require("@babel/runtime-corejs2/core-js/object/assign"), require("react"), require("prop-types"), require("../../propTypes"), require("../../UI/Interchange/Interchange"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.defineProperty, global.parseInt, global.assign, global.react, global.propTypes, global.propTypes, global.Interchange);
    global.LandscapeImage = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _defineProperty3, _parseInt2, _assign, _react, _propTypes, _propTypes2, _Interchange) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _parseInt2 = _interopRequireDefault(_parseInt2);
  _assign = _interopRequireDefault(_assign);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Interchange = _interopRequireDefault(_Interchange);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var convertToNumber = function convertToNumber(image) {
    (0, _assign.default)(image, {
      width: (0, _parseInt2.default)(image.width, 10),
      height: (0, _parseInt2.default)(image.height, 10)
    });
    return image;
  };

  var LandscapeImage = function LandscapeImage(_ref) {
    var className = _ref.className,
        images = _ref.images,
        title = _ref.title,
        url = _ref.url;

    var component = /*#__PURE__*/_react.default.createElement(_Interchange.default, {
      images: [_objectSpread(_objectSpread({
        format: 'landscape'
      }, convertToNumber(images[0])), {}, {
        alternateResolutions: images.map(function (image) {
          return convertToNumber(image);
        })
      })],
      thumbnailEnabled: false,
      title: title
    });

    if (url) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: url,
        className: className
      }, component);
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, component);
  };

  LandscapeImage.propTypes = {
    className: _propTypes.default.string,
    images: _propTypes.default.arrayOf(_propTypes2.default.image).isRequired,
    title: _propTypes.default.string,
    url: _propTypes.default.string
  };
  LandscapeImage.defaultProps = {
    className: '',
    images: [],
    title: '',
    url: ''
  };
  var _default = LandscapeImage;
  _exports.default = _default;
});